import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "./pages/Home";
import AnalyticsTracker from "./components/ga4/AnalyticsTracker";
import { resolveAccessLang } from "./utils/langCookie";

/** Redirect khi URL không có /en hoặc /vi — ưu tiên cookie_accesslang_quantera */
function LangRedirect() {
  const location = useLocation();
  const lang = resolveAccessLang("en");
  const hash = location.hash || "";
  const search = location.search || "";
  return <Navigate to={`/${lang}${search}${hash}`} replace />;
}

/** /vi/ → /vi, /en/ → /en — giữ PDF/document dưới /vi/file.pdf hoạt động đúng */
function StripTrailingSlash({ children }) {
  const location = useLocation();
  if (location.pathname === "/en/" || location.pathname === "/vi/") {
    const clean = location.pathname.slice(0, -1);
    return <Navigate to={`${clean}${location.search}${location.hash}`} replace />;
  }
  return children;
}

function App() {
  const [, setNonce] = useState("");

  useEffect(() => {
    async function fetchNonce() {
      try {
        const response = await fetch("/auth/nonce");
        const fetchedNonce = response.headers.get("x-nonce");
        if (fetchedNonce) {
          setNonce(fetchedNonce);
          window.nonce = fetchedNonce;
          document
            .getElementById("nonce-meta")
            ?.setAttribute("data-nonce", fetchedNonce);
        }
      } catch (error) {
        console.error(error);
      }
    }
    fetchNonce();
  }, []);

  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <StripTrailingSlash>
        <Routes>
          {/* Root không có /en|/vi → dựa cookie */}
          <Route path="/" element={<LangRedirect />} />

          <Route path="/en" element={<Home />} />
          <Route path="/vi" element={<Home />} />

          {/* Path khác không có locale → dựa cookie */}
          <Route path="*" element={<LangRedirect />} />
        </Routes>
      </StripTrailingSlash>
    </BrowserRouter>
  );
}

export default App;
